import { useEffect, useCallback } from "react";
import { APIProvider, Map, useMap } from "@vis.gl/react-google-maps";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

function Pins({ points, colorFor, onSelect }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google) return;
    const g = window.google;
    const bounds = new g.maps.LatLngBounds();
    const markers = (points || [])
      .filter((p) => p.lat != null && p.lon != null)
      .map((p) => {
        const m = new g.maps.Marker({
          position: { lat: p.lat, lng: p.lon },
          title: p.company_name || "",
          icon: { path: g.maps.SymbolPath.CIRCLE, scale: 8, fillColor: colorFor(p.category), fillOpacity: 1, strokeColor: "#0b0b0b", strokeWeight: 1.5 },
        });
        m.addListener("click", () => onSelect && onSelect(p));
        bounds.extend({ lat: p.lat, lng: p.lon });
        return m;
      });
    const clusterer = new MarkerClusterer({ map, markers });
    if (markers.length) {
      map.fitBounds(bounds, 60);
      g.maps.event.addListenerOnce(map, "idle", () => { if (map.getZoom() > 13) map.setZoom(13); });
    }
    return () => { clusterer.clearMarkers(); markers.forEach((m) => m.setMap(null)); };
  }, [map, points, colorFor, onSelect]);
  return null;
}

export default function ProspectMap({ points, categories = [], onSelect, height = 560 }) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const colorFor = useCallback((cat) => (categories.find((c) => c.key === cat)?.color) || "#9CA3AF", [categories]);
  if (!apiKey) return <div className="rounded border border-border p-4 text-sm text-muted-foreground">Mappa non disponibile (chiave Google Maps mancante).</div>;
  return (
    <div style={{ height }} className="rounded overflow-hidden border border-border" data-testid="prospect-map">
      <APIProvider apiKey={apiKey}>
        <Map defaultCenter={{ lat: 45.35, lng: 10.14 }} defaultZoom={6} gestureHandling="greedy" mapTypeId="roadmap" style={{ width: "100%", height: "100%" }}>
          <Pins points={points} colorFor={colorFor} onSelect={onSelect} />
        </Map>
      </APIProvider>
    </div>
  );
}
